export interface IParticipant {
  id: number;
  fullname: string;
  educational_organization: string;
  isSubmitted: boolean;
  hasFormProgress: boolean;
  isScored: boolean;
  main_position: string;
  nomination: number | null;
  phone_number: string;
  email: string;
  timezone: string;
  form_name: string;
};

export type TNominationMap = Record<number, string>;

export interface IDashboardStats {
  registrations: number;
  uniqueUniversities: number;
  listeners: number;
  completedTraining: number;
}

export interface IBarItem {
  id: number;
  name: string;
  shortName: string;
  registered: IParticipant[];
  nominationSelected: IParticipant[];
  formSubmitted: IParticipant[];
};

export interface IBarDataWithLabels {
  [key: string]: number | string;
  shortName: string;
  originalName: string;
}

export interface IPieChartDatum {
  id: string;
  label: string;
  value: number;
}

export type TCourseStatusKey =
  | 'filling'
  | 'waiting'
  | 'studying'
  | 'completed'
  | 'expelled';

export interface ICourseUniversityStats {
  id: number;
  name: string;
  shortName: string;
  filling: IParticipant[];
  waiting: IParticipant[];
  studying: IParticipant[];
  completed: IParticipant[];
  expelled: IParticipant[];
}

export interface ICourseDashboardStats {
  cards: Record<TCourseStatusKey, number>;
  byUniversity: ICourseUniversityStats[];
}

export type TSecondStageStatus = 'submitted' | 'in_progress' | 'not_started';

export interface ISemifinalParticipant extends IParticipant {
  secondStageStatus: TSecondStageStatus;
}

export interface ISemifinalDashboardStats {
  cards: {
    submitted: number;
    inProgress: number;
    notStarted: number;
  };
  participants: ISemifinalParticipant[];
}

export const EMPTY_SEMIFINAL_STATS: ISemifinalDashboardStats = {
  cards: { submitted: 0, inProgress: 0, notStarted: 0 },
  participants: [],
};
